import { BRAND } from '../brand';
import { ENTITY, EFFECTIVE_DATE, VERSION, CPO_ROLE, CONTACT_DEPT, CONTACT_EMAIL } from './meta';

export const PRIVACY = {
  title: '개인정보처리방침',
  version: VERSION,
  effectiveDate: EFFECTIVE_DATE,
  sections: [
    {
      id: 'general',
      heading: '제1조 (총칙)',
      body: [
        `${ENTITY}(이하 "회사")는 Apple 파트너사 교육 플랫폼 ${BRAND}(이하 "서비스")를 운영하며, 「개인정보 보호법」에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하게 처리할 수 있도록 본 개인정보처리방침을 수립·공개합니다.`,
        `본 방침은 ${EFFECTIVE_DATE}부터 적용됩니다.`,
      ],
    },
    {
      id: 'items',
      heading: '제2조 (수집하는 개인정보의 항목)',
      body: [
        '회사는 이용자가 소속된 파트너사에 적용된 개인정보 비식별화 설정에 따라 서로 다른 항목을 수집합니다. 본인에게 적용되는 구분은 소속 파트너사 관리자를 통해 확인하실 수 있습니다.',
        '비식별화가 적용된 파트너사의 경우에도, 최초 로그인 시점에는 로그인 제공자로부터 이름·이메일 주소·프로필 사진을 전달받아 계정에 저장되며 온보딩(가입 절차) 완료 시 삭제됩니다. 온보딩을 완료하지 않은 계정에는 온보딩 완료 또는 계정 삭제 시까지 해당 정보가 남아 있을 수 있습니다.',
      ],
      table: {
        columns: ['구분', '수집 항목', '수집 방법'],
        rows: [
          [
            '비식별화 적용 파트너사',
            '로그인 제공자가 부여한 고유 식별자(UID). 이름·이메일 주소·프로필 사진은 온보딩 완료 시 삭제되며 이후 보유하지 않습니다.',
            '소셜 로그인',
          ],
          [
            '일반 파트너사',
            '이름, 이메일 주소, 프로필 사진, 로그인 고유 식별자(UID)',
            '소셜 로그인 및 온보딩 입력',
          ],
          [
            '공통(서비스 이용 과정에서 생성)',
            '역할극 음성 데이터 및 그 텍스트 변환본, 웹캠 스냅샷 이미지, 학습·평가 이용내역(세션 기록, 평가 결과, 퀴즈 응시 내역)',
            '서비스 이용 시 자동 수집',
          ],
          [
            '지원 요청 내역',
            '문의 내용, 첨부 이미지, 접수 시점의 화면 경로 및 검색어, 브라우저 정보(User-Agent) 및 화면 크기',
            '서비스 내 지원 요청 시 입력 및 자동 수집',
          ],
        ],
      },
    },
    {
      id: 'purpose',
      heading: '제3조 (개인정보의 수집·이용 목적)',
      body: ['회사는 수집한 개인정보를 다음의 목적으로만 이용하며, 목적이 변경되는 경우 사전에 정보주체의 동의를 받습니다.'],
      list: [
        '회원 관리 — 가입 의사 확인, 서비스 이용 자격 검증, 부정이용 방지',
        '서비스 제공 — AI 역할극 시뮬레이션 진행, 음성 인식 및 텍스트 변환, 평가 및 피드백 생성, 학습 진도 관리',
        '본인 확인 — 등록된 이용자 본인이 평가에 참여하고 있는지 확인',
        '교육 성과 관리 및 보고 — 파트너사별 교육 이수 현황 확인 및 학습 성과 관리',
        '서비스 품질 개선 — 이용 통계 분석, 오류 개선, 운영 환경 최적화',
      ],
    },
    {
      id: 'retention',
      heading: '제4조 (개인정보의 보유 및 이용 기간)',
      body: ['회사는 아래 기간이 경과하거나 처리 목적이 달성된 경우 해당 개인정보를 지체 없이 파기합니다.'],
      table: {
        columns: ['항목', '보유 기간'],
        rows: [
          ['계정 정보(UID, 이름, 이메일 주소)', '서비스 이용 계약 종료 시까지'],
          ['음성 데이터의 텍스트 변환본, 평가·학습 이용내역', '서비스 이용 계약 종료 시까지'],
          ['역할극 원본 음성 파일', '서비스 이용 계약 종료 시까지 (종료 후 30일 이내 파기)'],
          ['웹캠 스냅샷 이미지', '서비스 이용 계약 종료 시까지 (종료 후 30일 이내 파기)'],
        ],
      },
    },
    {
      id: 'third-party',
      heading: '제5조 (개인정보의 제3자 제공)',
      body: [
        '회사는 정보주체의 동의를 받은 범위 내에서만 개인정보를 제3자에게 제공합니다. 비식별화가 적용된 파트너사 소속 이용자의 경우, 회사가 이름·이메일 주소를 보유하지 않으므로 식별정보는 제공되지 않습니다.',
      ],
      table: {
        columns: ['제공받는 자', '제공 목적', '제공 항목', '보유·이용 기간'],
        rows: [
          [
            'Apple 교육팀(Apple Korea)',
            '파트너사별 교육 이수 현황 확인 및 학습 성과 관리, 본인 확인 및 평가 검증',
            '이메일 주소(일반 파트너사에 한함), 학습·평가 이용내역, 웹캠 스냅샷 이미지, 역할극 음성 녹음',
            '교육 프로그램 종료 시까지',
          ],
          [
            '이용자가 소속된 파트너사의 관리자',
            '소속 직원의 교육 이수 및 성과 관리, 본인 확인 및 평가 검증',
            '이메일 주소(일반 파트너사에 한함), 학습·평가 이용내역, 웹캠 스냅샷 이미지, 역할극 음성 녹음',
            '서비스 이용 계약 종료 시까지',
          ],
        ],
      },
    },
    {
      id: 'delegation',
      heading: '제6조 (개인정보 처리의 위탁)',
      body: ['회사는 서비스 제공을 위하여 아래와 같이 개인정보 처리 업무를 위탁하고 있으며, 수탁자가 개인정보를 안전하게 처리하도록 관리·감독합니다.'],
      table: {
        columns: ['수탁자', '위탁 업무의 내용'],
        rows: [
          ['OpenAI, L.L.C.', '역할극 음성의 실시간 인식·응답 생성, 음성의 텍스트 변환, 평가 결과 생성'],
          ['Google LLC', '로그인 인증 및 계정 식별자 관리(Firebase), 역할극 대화 내용에 대한 제품 지식 평가 및 퀴즈 문항 생성(Gemini)'],
          ['Amazon Web Services, Inc.', '서비스 인프라 운영 및 데이터 보관'],
        ],
      },
    },
    {
      id: 'overseas',
      heading: '제7조 (개인정보의 국외 이전)',
      body: [
        '회사는 서비스 제공을 위하여 아래와 같이 개인정보를 국외로 이전하고 있습니다.',
        '회사가 데이터를 보관하는 클라우드 인프라(Amazon Web Services)는 국내 리전(서울, ap-northeast-2)을 사용합니다. 따라서 역할극 원본 음성 파일, 웹캠 스냅샷 이미지 등 회사가 보관하는 데이터의 저장 위치는 대한민국 내이며, 국외 이전에 해당하지 않습니다.',
        '위 국외 이전은 「개인정보 보호법」 제28조의8 제1항 제3호에 따라 계약의 이행 및 정보주체 편의 증진을 위하여 필요한 처리위탁으로서, 본 개인정보처리방침을 통해 공개하는 방법으로 이루어집니다.',
        '이용자는 제14조의 연락처를 통하여 개인정보의 국외 이전을 거부할 수 있습니다. 다만 위 이전은 AI 역할극 시뮬레이션 및 자동 평가 기능의 수행에 본질적으로 수반되는 것이므로, 거부하시는 경우 해당 기능의 이용이 제한됩니다.',
      ],
      table: {
        columns: ['이전받는 자', '이전 국가', '이전 항목', '이전 시기 및 방법', '이용 목적 및 보유 기간'],
        rows: [
          [
            'OpenAI, L.L.C.',
            '미국',
            '역할극 음성 데이터 및 텍스트',
            '서비스 이용 시 실시간 네트워크 전송',
            'AI 고객 시뮬레이션 및 평가 생성 / OpenAI의 데이터 보존 정책에 따름',
          ],
          [
            'Google LLC',
            '미국',
            '로그인 고유 식별자(UID) 및 인증 정보, 역할극 대화 내용의 텍스트 변환본',
            '로그인 시 및 평가 처리 시 네트워크 전송',
            '로그인 인증, 제품 지식 평가 및 퀴즈 문항 생성 / Google의 데이터 보존 정책에 따름',
          ],
        ],
      },
    },
    {
      id: 'automated',
      heading: '제8조 (자동화된 결정)',
      body: [
        '회사는 이용자의 역할극 수행 내용을 인공지능이 평가 기준에 따라 자동으로 분석·채점하며, 그 결과는 소속 파트너사 관리자 및 Apple 교육팀에게 제공됩니다.',
        '자동화된 결정의 기준과 절차는 다음과 같습니다. 인공지능이 역할극 대화의 텍스트 변환본을 해당 과제에 설정된 평가 기준 항목별로 분석하여 항목별 점수와 피드백을 생성하며, 그 결과가 학습 대시보드 및 관리자 화면에 반영됩니다.',
        '이용자는 자동화된 결정에 대하여 설명을 요구하거나 이의를 제기할 수 있으며, 해당 결정을 거부할 수 있습니다. 신청은 서비스 내 지원 요청 기능 또는 제14조의 연락처를 통해 접수하실 수 있습니다. 다만 자동 평가는 역할극 평가 기능의 본질적 요소이므로, 거부하시는 경우 해당 기능의 이용이 제한될 수 있습니다.',
      ],
    },
    {
      id: 'rights',
      heading: '제9조 (정보주체의 권리와 행사 방법)',
      body: ['이용자는 언제든지 다음의 권리를 행사할 수 있습니다.'],
      list: [
        '개인정보 열람 요구',
        '오류가 있는 경우 정정 요구',
        '삭제 요구',
        '처리 정지 요구',
        '개인정보 수집·이용 및 제3자 제공에 대한 동의 철회',
      ],
    },
    {
      id: 'withdrawal',
      heading: '제10조 (동의 철회)',
      body: [
        '이용자는 제14조의 연락처 또는 소속 파트너사 관리자를 통하여 언제든지 동의를 철회할 수 있습니다.',
        '다만 음성·웹캠 수집에 대한 동의는 역할극 평가의 필수 요소이므로, 철회 시 해당 서비스의 이용이 제한될 수 있습니다.',
      ],
    },
    {
      id: 'destruction',
      heading: '제11조 (개인정보의 파기)',
      body: [
        '회사는 보유 기간이 경과하거나 처리 목적이 달성된 개인정보를 지체 없이 파기합니다.',
        '전자적 파일 형태의 정보는 복구가 불가능한 방법으로 영구 삭제합니다. 역할극 원본 음성 파일 및 웹캠 스냅샷 이미지는 소속 파트너사와 회사 간 서비스 이용 계약이 종료된 때로부터 30일 이내에 파기합니다.',
      ],
    },
    {
      id: 'security',
      heading: '제12조 (개인정보의 안전성 확보 조치)',
      body: ['회사는 개인정보의 안전한 처리를 위하여 다음의 조치를 취하고 있습니다.'],
      list: [
        '개인정보 접근 권한의 최소화 및 접근 기록 관리',
        '전송 구간 암호화(HTTPS) 적용',
        '저장 구간 암호화 — 역할극 음성 파일 및 웹캠 스냅샷 이미지는 서버 측 암호화(AES-256)가 적용된 저장소에 보관',
        '역할극 음성 녹음 및 웹캠 스냅샷 이미지에 대한 회사 임직원의 접근 최소화 및 권한 통제',
        '비식별화가 적용된 파트너사의 경우 온보딩 완료 시 이름·이메일 주소·프로필 사진을 삭제하는 구조적 조치',
      ],
    },
    {
      id: 'cookies',
      heading: '제13조 (자동 수집 장치의 설치·운영 및 그 거부에 관한 사항)',
      body: [
        '회사는 광고성 쿠키나 행태정보 수집 도구를 사용하지 않습니다. 다만 로그인 상태를 유지하기 위하여 이용자 브라우저의 로컬 저장소(localStorage)에 인증 토큰과 계정 정보를 저장하고, 인트로 화면의 1회 표시 여부를 세션 저장소(sessionStorage)에 저장합니다.',
        '이용자는 브라우저 설정을 통하여 위 저장을 거부할 수 있습니다. 다만 거부하는 경우 로그인 상태가 유지되지 않아 서비스 이용이 제한됩니다.',
      ],
    },
    {
      id: 'cpo',
      heading: '제14조 (개인정보 보호책임자 및 문의처)',
      body: ['개인정보 처리에 관한 문의, 열람·정정·삭제 요구, 동의 철회는 아래로 접수하실 수 있습니다.'],
      table: {
        columns: ['구분', '내용'],
        rows: [
          ['개인정보 보호책임자', CPO_ROLE],
          ['담당 부서', CONTACT_DEPT],
          ['연락처', CONTACT_EMAIL],
        ],
      },
    },
    {
      id: 'remedies',
      heading: '제15조 (권익침해 구제방법)',
      body: [
        '이용자는 개인정보 침해로 인한 구제를 받기 위하여 아래 기관에 분쟁 해결이나 상담 등을 신청할 수 있습니다.',
      ],
      table: {
        columns: ['기관', '연락처'],
        rows: [
          ['개인정보분쟁조정위원회', '1833-6972 (www.kopico.go.kr)'],
          ['개인정보침해신고센터', '118 (privacy.kisa.or.kr)'],
          ['대검찰청 사이버수사과', '1301 (www.spo.go.kr)'],
          ['경찰청 사이버수사국', '182 (ecrm.police.go.kr)'],
        ],
      },
    },
    {
      id: 'changes',
      heading: '제16조 (개인정보처리방침의 변경)',
      body: [
        '본 방침의 내용이 추가·삭제 또는 수정되는 경우, 회사는 변경 사항의 시행 7일 전부터 서비스 내 공지를 통해 안내합니다.',
        '다만 이용자 권리의 중대한 변경이 있는 경우에는 30일 전에 안내하고, 필요한 경우 다시 동의를 받습니다.',
      ],
    },
  ],
};
